<template>
  <div class="detailPage" :class="{'hashead hasservice':!isPC}">
    <div class="loading" v-if="estateArr.length==0"><i class="el-icon-loading"></i></div>
    <LeaveTel ref="LeaveTel" :service="!isPC" :hasOnline="true" :estate="[estateVO.phone2,estateId,estateVO.name,'楼盘']" v-if="estateArr.length!=0" @setError="getError"></LeaveTel>
    <Header v-if="isPC"></Header>

    <WapHeader ref="wHeader" v-if="!isPC&&estateVO" :showhome="true" :showlogo="true"></WapHeader>
    <div class="pmenuwrap" v-if="!isPC&&pmItem!=''">
      <i class="m-icon mi-back" @click="$refs.wHeader.goback()"></i>
      <div class="pmenubox">
        <span @click="goAnchor('lp')" :class="{'active':pmItem=='lp'}">楼盘</span>
        <span @click="goAnchor('hx')" v-if="showHX&&houseList.length>0" :class="{'active':pmItem=='hx'}">户型</span>
        <span @click="goAnchor('dtai')" v-if="newsList.bulletinVO&&newsList.bulletinVO.title!=null" :class="{'active':pmItem=='dtai'}">动态</span>
<!--        <span @click="goAnchor('map')" :class="{'active':pmItem=='map'}">周边</span>-->
      </div>
    </div>

    <div class="box">
      <el-breadcrumb separator-class="el-icon-arrow-right" v-if="isPC">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item v-if="estateVO">{{estateVO.name}}</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="b-img">
        <img v-if="estateVO&&amindex==2" v-lazy="estateVO.path +'&type=1'" @click="openAlbum=true" />

        <img v-if="amindex==1" v-lazy="estateVO.path +'&type=1'" @click="currVideoPath=estateVO.tvUrl" />
        <i v-if="amindex==1" class="i-video" @click="currVideoPath=estateVO.tvUrl"></i>
        <!-- <span class="album" v-if="estateArr.estatePhotoVO"><i class="m-icon"></i>相册1/{{estateArr.estatePhotoVO.totalNumber}}</span> -->

        <div class="albummenu" v-if="estateVO">
          <div class="ambg">
            <a :href="estateVO.vrUrl" v-if="estateVO.vrUrl&&estateVO.vrUrl!=''">VR</a>
            <span :class="{'active':amindex==1}" @click="amindex=1" v-if="estateVO.tvUrl&&estateVO.tvUrl!=''">视频</span>
            <span :class="{'active':amindex==2}" @click="amindex=2" v-if="estateArr.estatePhotoVO">图片</span>
          </div>
          <div v-if="estateArr.estatePhotoVO" class="albumcount">01/{{estateArr.estatePhotoVO.totalNumber}}</div>
        </div>
      </div>
      <VideoPlay :videoPath="currVideoPath" @clearPath="currVideoPath=''"></VideoPlay>
      <div class="b-info">
        <!-- 楼盘信息 -->
        <EDIntro id="lp" :isPC="isPC" :estateVO="estateVO" :priceVO="estateArr.priceVO" :propertyTypeList="estateArr.propertyTypeList" :estateTagsList="estateTagsList" :estateActivity="busList" :houseList="houseList" @leaveClick="leaveClick" @leaveCallClick="leaveCallClick"></EDIntro>
        <!-- 周边地铁 -->
        <div id="dt">
          <div class="relativebox" v-if="showDT">
            <p class="btitle">周边地铁</p>
            <div class="sublinewrap clearfix">
              <p v-for="(item, index) in subwayList" :key="index"><i class="m-icon mi-subway"></i><b>{{item.subway}}</b>{{item.subwaySite}}站（约{{item.quousque}}米）</p>
              <div class="leave-box" @click="leaveClick(9)"><span>区域规划抢先通知</span></div>
            </div>
          </div>
        </div>
        <!-- 户型分析 -->
        <div id="hx"><EDHType v-if="showHX" class="relativebox" :isPC="isPC" :houseList="houseList" :houseItem="houseItem" :estateId="estateId" @leaveClick="leaveClick" @leaveCallClick="leaveCallClick" @leaveClickPC="leaveClickPC" :errMsg="errMsg" @closePop="closePop"></EDHType></div>
        <!-- 专属顾问 -->
        <div id="gw"><EDAdviser v-if="showGW" :isPC="isPC" :adviserVO="estateArr.adviserVO" @leaveCallClick="leaveCallClick" @leaveClick="leaveClick"></EDAdviser></div>
        <!-- 区位分析 推荐理由 楼盘动态 -->
        <div id="new">
          <EDNews v-if="showNew&&newsList.locationAnalysisList&&newsList.locationAnalysisList.length>0" class="relativebox" :quwei="newsList.locationAnalysisList" @leaveClick="leaveClick"></EDNews>
          <EDReason v-if="showNew&&estateArr.estateReasonList" class="relativebox" :liyou="estateArr.estateReasonList" @leaveClick="leaveClick"></EDReason>
          <div v-if="!isPC" class="relativebox">
            <p class="btitle cj">
              <span :class="cjtitle==0?'active':''" @click="cjtitle=0">成交价查询</span><span :class="cjtitle==1?'active':''" @click="cjtitle=1">余房查询</span>
            </p>
            <div class="mhimg">
              <div class="cjimg" v-if="cjtitle==0"></div>
              <div class="cjimg yf" v-if="cjtitle==1"></div>
              <div class="leave-box" v-if="cjtitle==0"><span @click="leaveClick(34)">了解更多成交价格</span></div>
              <div class="leave-box" v-if="cjtitle==1"><span @click="leaveClick(35)">了解更多余房</span></div>
            </div>
          </div>
          <EDNews id="dtai" v-if="showNew" class="relativebox" :dongtai="newsList.bulletinVO" :daogou="newsList.informationVO" @leaveClick="leaveClick"></EDNews>
        </div>
        <div v-if="!isPC" class="relativebox">
          <p class="btitle"><span>专属置业报告</span></p>
          <div class="mhimg">
            <div class="bgimg"></div>
            <div class="leave-box"><span @click="leaveClick(36)">订阅专属置业报告</span></div>
          </div>
        </div>
        <!-- 楼盘详情 -->
        <div id="xq"><EDDetail v-if="showXQ" class="relativebox" :propertyTypeList="estateArr.propertyTypeList" :salePriceList="estateArr.salePriceList" :estateDecorateList="estateArr.estateDecorateList" :priceVO="estateArr.priceVO" :estateVO="estateVO" :estateDeveloperVO="estateArr.estateDeveloperVO" :estateStewardVO="estateArr.estateStewardVO" @leaveClick="leaveClick"></EDDetail></div>
        <!-- <div v-if="!isPC && estateVO && estateVO.bajxsShow==1" class="relativebox"> -->
        <div class="relativebox">
          <p class="btitle"><span>备案价查询</span></p>
          <div class="mhimg">
            <div class="baimg"></div>
            <div class="leave-box"><span @click="leaveClick(39)">了解全部备案价格</span></div>
          </div>
        </div>
        <!-- 周边配套 -->
        <!-- 楼盘其他物业类型 -->
        <div v-if="otherPropertyList.length>0">
          <p class="btitle">该楼盘其他类型物业</p>
          <div class="otherwrap">
            <ul class="clearfix" :style="'width:'+(!isPC?235*otherPropertyList.length:200*otherPropertyList.length)+'px'">
              <li v-for="(item, index) in otherPropertyList" :key="index"  @click="$router.push({path:'estateDetail?estateId='+item.pkId});reload();">
                <div class="o-left">
                  <div class="imgwrap">
                    <img v-lazy="item.path">
                    <div class="bdicon">
                      <i v-if="item.vrUrl&&item.vrUrl!=''" class="i-vr"></i>
                      <i v-if="item.tvUrl&&item.tvUrl!=''" class="i-tv"></i>
                    </div>
                  </div>
                  <p class="title">{{item.name}}</p>
                </div>
                <div class="o-right">
                  <p class="price">{{item.price&&item.price!=null?item.price:'售价待定'}}</p>
                  <p class="area">{{item.coveredArea}}</p>
                  <p class="type">{{item.value}}</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <!-- 同价位热盘 -->
        <div class="likewrap" id="guss">
          <p class="btitle">同价位热盘</p>
          <EstateList @takeCall="leaveCallClick" :isPC="isPC" :estateObj="estateVO" v-if="showGuss&&estateVO!=null" :isGuess="true"></EstateList>
          <div v-if="!isPC" class="leave-box"><span @click="leaveClick(37)">了解附近房价和租房</span></div>
        </div>
      </div>
    </div>
    <Footer></Footer>
    <!-- 相册 -->
    <div v-if="openAlbum" class="popwrap">
      <div class="popbox">
        <span @click.self="openAlbum=false" class="el-icon-error"></span>
        <div class="estateInfo">
          <p class="etitle">{{estateVO.name}}</p>
          <p class="ephone" v-if="estateVO.phone2">{{estateVO.phone2}}</p>
        </div>
        <Album :eId="estateId"></Album>
      </div>
    </div>
  </div>
</template>

<script>
import Global from '@/components/public/Global'
import Header from '@/components/public/Header'
import WapHeader from '@/components/public/WapHeader'
import Footer from '@/components/public/Footer'
import VideoPlay from '@/components/public/VideoPlay'
import recordHttp from '../store/recordPage.js'
export default {
  inject:['reload'],
  name:'EstateDetail',
  components:{
    'Header': Header,
    'WapHeader':WapHeader,
    'Footer':Footer,
    'VideoPlay':VideoPlay,
    LeaveTel: resolve => require(['@/components/public/LeaveTel'],resolve),
    EDIntro: resolve => require(['@/components/public/EDIntro'],resolve),
    EDHType: resolve => require(['@/components/public/EDHType'],resolve),
    EDAdviser: resolve => require(['@/components/public/EDAdviser'],resolve),
    EDNews: resolve => require(['@/components/public/EDNews'],resolve),
    EDReason: resolve => require(['@/components/public/EDReason'],resolve),
    EDDetail: resolve => require(['@/components/public/EDDetail'],resolve),
    EstateList: resolve => require(['@/components/public/EstateList'],resolve),
    // Maps: resolve => require(['@/components/Maps'],resolve),
    Album: resolve => require(['@/components/Album'],resolve),
  },
  data () {
    return {
      isPC:this.$store.state.isPC,
      estateArr:[],
      estateVO:null,
      estateId:this.$route.query.estateId,
      busList:null,
      houseList:[],
      newsList:[],
      subwayList:[],
      houseItem:[],
      showLeave:false,
      leaveNumber:'',
      openAlbum:false,
      showDT:false,
      showHX:false,
      showNew:false,
      showGuss:false,
      showGW:false,
      showXQ:false,
      showMap:false,
      amindex:2,
      currVideoPath:'',
      otherPropertyList:[],
      estateTagsList:[],
      pmItem:'',
      isClick:0,
      errMsg:'',
      cjtitle:0,
      bdmapChannel: Global.channel_bdmap
    }
  },
  computed:{
    listenIsPC(){
      return this.$store.state.isPC;
    }
  },
  watch:{
    listenIsPC:function(boo){
      this.isPC = this.$store.state.isPC;
    }
  },
  created(){window.scrollTo(0,0);},
  mounted(){
    var _this = this;
    _this.getEstateDetail(_this.estateId);
    _this.getBus(_this.estateId);
    window.addEventListener('scroll', _this.handleScroll);
    document.querySelector('link[name="recom"]').setAttribute('href', '');
  },
  destroyed(){
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods:{
    goAnchor(id){
      this.isClick=1;
      this.pmItem=id;
      document.getElementById(id).scrollIntoView();
    },
    handleScroll(){
      if(this.isSee('dt')&&!this.showDT){
        this.showDT=true;
        this.getSubway(this.estateId);
      }
      if(this.isSee('hx')&&!this.showHX){
        this.showHX=true;
        this.getHouseList(this.estateId);
      }
      if(this.isSee('gw')&&!this.showGW){
        this.showGW=true;
      }
      if(this.isSee('new')&&!this.showNew){
        this.showNew=true;
        this.getNews(this.estateId);
      }
      if(this.isSee('xq')&&!this.showXQ){
        this.showXQ=true;
      }
      if(this.isSee('map')&&!this.showMap){
        this.showMap=true;
      }
      if(this.isSee('guss')&&!this.showGuss){
        this.showGuss=true;
      }
      if(this.isClick==0){
        this.setMenuActive()
      }
      this.isClick=0;
    },
    setMenuActive(){
      if(this.isXiaoyu('lp')&&this.isDayu('hx')){
        this.pmItem = 'lp';
      }else if(this.isXiaoyu('hx')&&this.isDayu('dtai')){
        this.pmItem = 'hx';
      }else if(this.isXiaoyu('dtai')){
        this.pmItem = 'dtai';
      }else{
        this.pmItem = '';
      }
    },
    isDayu(id){
      return document.getElementById(id)&&document.getElementById(id).getBoundingClientRect().top>0
    },
    isXiaoyu(id){
      return document.getElementById(id)&&document.getElementById(id).getBoundingClientRect().top<=0
    },
    isSee(id){
      if(document.getElementById(id)){
        return document.getElementById(id).getBoundingClientRect().top<document.documentElement.clientHeight-30
      }else{
        return false
      }
    },
    getEstateDetail:function(id){
      let estateApiUrl = '/api/estate/getEstateDetail?estateId='+id;
      let channel = sessionStorage.getItem("channel");
      if (channel && channel.indexOf(this.bdmapChannel) !== -1) {
        estateApiUrl += '&channel=' + this.bdmapChannel;
      }
      this.$http.get(estateApiUrl).then((response)=>{
        this.estateArr=response.data.result;
        this.estateVO=this.addObj(this.estateArr.qtEstateVO,this.estateArr.estateVO);
        this.handleScroll();
        if(this.estateVO.tvUrl!=null && this.estateVO.tvUrl!=''){
          this.amindex=1
        }else{
          this.amindex=2
        }

        var url = '/api/estate/getEstateOtherPropertyList?estateId='+id;
        if(this.estateArr.qtEstateVO.sourceId){
          url = url + '&sourceId='+this.estateArr.qtEstateVO.sourceId;
        }
        this.$http.get(url).then((response)=>{
          this.otherPropertyList=response.data.result.list;
        }).catch((response)=>{
          console.log(response)
        })

        recordHttp.recordPage(this,null,this.estateVO.pkId,this.estateVO.name,this.estateVO.phone2);

      }).catch((response)=>{
        console.log(response)
      })
      this.$http.get('/api/estate/getEstateDetailTags?estateId='+id).then((response)=>{
        this.estateTagsList=response.data.result.estateTagList;
      }).catch((response)=>{
        console.log(response)
      })
    },
    addObj(obj1,obj2){
      for(var key in obj2){
        if(obj1.hasOwnProperty(key)&&obj1[key]!=null) continue;
        if(obj2[key]!=null){
          obj1[key]=obj2[key];
        }
      }
      return obj1;
    },
    getBus(id){
      this.$http.get('/api/estate/getEstateDetailActivity?estateId='+id).then((response)=>{
        this.busList=response.data.result.estateActivity;
      }).catch((response)=>{
        console.log(response)
      })
    },
    getSubway:function(id){
      this.$http.get('/api/estate/getEstateDetailSubway?estateId='+id).then((response)=>{
        this.subwayList=response.data.result.estateSubwayList;
        if(this.subwayList && this.subwayList.length==0 && document.getElementById('dt')){
          document.getElementById('dt').remove();
        }
      }).catch((response)=>{
        console.log(response)
      })
    },
    getHouseList:function(id){
      this.$http.get('/api/estate/getEstateDetailHouseList?estateId='+id).then((response)=>{
        this.houseList=response.data.result.estateHouseList;
        for(var i=0;i<this.houseList.length;i++){
          this.houseItem=this.houseItem.concat(this.houseList[i].houseTypeList)
        }
        if(this.houseList.length==0){
          document.getElementById('hx').remove();
        }
      }).catch((response)=>{
        console.log(response)
      })
    },
    getNews:function(id){
      this.$http.get('/api/estate/getEstateDetailInformation?estateId='+id).then((response)=>{
        this.newsList=response.data.result;
        if(this.newsList.length==0){
          document.getElementById('new').remove();
        }
      }).catch((response)=>{
        console.log(response)
      })
    },
    closePop(data){
      if(data==true){
        this.errMsg='';
      }
    },
    getError:function(data){
      this.errMsg=data;
    },
    leaveClickPC(phone){
      this.$refs.LeaveTel.setParams(15,this.estateId,this.estateVO.name,'户型','','',phone);
      this.$refs.LeaveTel.sendFromInLine();
    },
    leaveClick(index){
      if (index == 40) {
        let address = this.estateVO.stName + "-" + this.estateVO.scName + " | " +this.estateVO.positionDetail;

        this.$refs.LeaveTel.leaveClick(index,this.estateId,this.estateVO.name,'楼盘'+'&&'+address+"&&"+this.estateVO.phone2);
      } else {
        this.$refs.LeaveTel.leaveClick(index,this.estateId,this.estateVO.name,'楼盘');
      }
    },
    leaveCallClick(phone,eid,ename,column){
      if(eid==undefined){
        eid=this.estateId
      }
      if(ename==undefined){
        ename=this.estateVO.name
      }
      if(column==undefined){
        column='楼盘'
      }
      this.$refs.LeaveTel.leaveCallClick(phone,eid,ename,column);
    },
    getLeaveData:function(boo,arr){
      this.showLeave = boo;
    },
    // mapClick:function(){
    //   this.$router.push({path:'/mapDetail?estateId='+this.estateId});
    // },
    pcAlbum(){
      this.openAlbum=true;
    },
    // 微信获取密钥分享
    getSignatureShare(){
      var shareObj = {
        link: window.location.href,
        title: document.title+'-楼盘详情',
        desc: this.estateVO.name,
        imgUrl: this.estateVO.path,
        logoIndex: this.$store.state.domainIndex
      };
      this.$http.get('/api/wechat/getSignatureInfo?url='+shareObj.link).then((response)=>{
        if(response && response.data.result){
          this.share.weixinShare(shareObj, response.data.result);
        }
      }).catch((response)=>{
        console.log(response)
      })
    },
  }
}
</script>

<style scoped lang="less">
  .hasservice{padding-bottom:60px;}
  .b-img{position:relative;height:210px;}
  .b-img img{width:100%;height:100%;}
  /*.album{position:absolute;width:100px;left:50%;margin-left:-50px;bottom:10px;text-align:center;color:#fff;font-size:12px;line-height:18px;cursor:pointer;}
  .album .m-icon{width:18px;height:18px;background-position:-148px -15px;display:block;margin:0 auto 3px;}*/

  .albummenu{position:absolute;bottom:15px;z-index:2;text-align:center;left:0;right:0;}
  .albummenu .ambg,.albummenu .albumcount{background:rgba(0,0,0,.6);border-radius:18px;padding:6px;font-size:0;display:inline-block;color:#fff;}
  .albummenu span,.albummenu a{display:inline-block;width:48px;font-size:12px;line-height:20px;color:#fff;border-radius:10px;cursor:pointer;}
  .albummenu span+span,.albummenu a+span{margin-left:8px;}
  .albummenu span.active{background:#ffd800;color:#615200;}
  .albummenu .albumcount{font-size:12px;padding:2px 10px 0;line-height:30px;height:30px;position:absolute;right:15px;bottom:0;}
  .i-video{position:absolute;left:50%;top:50%;margin-left:-28px;margin-top:-28px;width:56px;height:56px;border-radius:50%;background:#fff url(../assets/images/i-video.png) 21px center no-repeat;background-size:19px;box-shadow:2px 2px 20px rgba(0,0,0,.5)}

  .b-info{padding:15px 15px 5px;background:#fff;position:relative;line-height:20px;font-size:12px;overflow:hidden;}
  .sublinewrap{margin-top:15px;font-size:14px;position:relative;z-index:1}
  .sublinewrap p{color:#777;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
  .sublinewrap p b,.sublinewrap p em{color:#555;margin:0 5px;font-weight:400;}
  .sublinewrap p+p{margin-top:10px;}
  .mi-subway{width:13px;height:15px;background-position:-180px -63px;vertical-align:top;margin-top:2px;margin-right:5px;}
  /*动态加载高度*/
  #dt,#hx,#gw,#new,#map,#guss,#xq{min-height:100px;}
  .otherwrap{overflow: auto;-webkit-overflow-scrolling: touch;padding-right:0;padding-top:8px;
    ul{width:999%;}
    .o-left,.o-right{float:left;}
    .o-left{width:115px;margin-right:10px;}
    .o-right{line-height:25px;padding-top:5px;width:90px}
    .imgwrap{display:block;width:100%;height:83px;position:relative;
      img{background-color:#ededed;border-radius:4px;width:100%;height:100%;object-fit:cover;}
    }
    .title{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block;text-align:center;font-size:14px;font-weight:700;line-height:30px}
    .price{color:#ff4d30;font-size:15px;font-weight:700;}
    .type{font-weight:700;}
  }

@media (max-width:768px){
  .maphover{position:absolute;left:0;right:0;top:0;bottom:0;z-index:1;}
  .popwrap{position:fixed;left:0;right:0;top:0;bottom:60px;z-index:11;}
  .popbox{width:100%;height:100%;}
  .el-icon-error{position:absolute;right:12px;top:12px;font-size:30px;z-index:3;cursor:pointer;color:#fff;opacity:0.8}
  .estateInfo{display:none;}
  .detailPage /deep/ .leave-box{margin-top:20px;}
  .detailPage /deep/ .btitle{margin-left:-15px;}
  .detailPage /deep/ .header{position:absolute;}
  .pmenuwrap{position:fixed;top:0;left:0;right:0;height:46px;text-align:center;background:#fff;z-index:9;box-shadow:0 0 3px #ddd;padding-left:40px;}
  .pmenuwrap .mi-back{width:11px;height:19px;background-position:-150px -79px;position:absolute;left:15px;top:14px;}
  .pmenubox{display:table;width:100%;
    span{display:table-cell;line-height:46px;}
  }
  #hx,#dtai,#map{padding-top:31px;margin-top:-31px;}
  #lp{padding-top:66px;}
  .b-info{margin-top:-61px;}
  .b-img{position:relative;z-index:1;}
  #dtai{border-top:0;
    &:before{border-top:10px solid #f1f1f1;content:"";display:block;margin:0 -15px;}
  }
  .btitle.cj span{display:inline-block;color:#999;}
  .btitle.cj span+span{margin-left:16px;}
  .btitle.cj span.active{color:#333;position:relative;}
  .btitle.cj span.active:after{content:"";position:absolute;left:10px;right:10px;bottom:0;}
  .mhimg{margin-top:10px;}
  .mhimg .leave-box{margin-top:0px;}
  .likewrap .leave-box{margin-top:5px;}
}
@media (min-width:769px){
  .el-breadcrumb{font-size:12px;padding-top:20px;padding-bottom:20px;line-height:20px;}
  .detailPage /deep/ .el-breadcrumb__separator{margin:0 3px;}
  .detailPage /deep/ .el-breadcrumb__inner a, .detailPage /deep/ .el-breadcrumb__inner.is-link{font-weight:400;}
  .box{position:relative;}
  .b-img{width:60%;height:430px;position:absolute;left:0;top:60px;z-index:1;}
  .b-img img{object-position:100% 100%;border-radius:5px;}
  .b-info{padding:0;font-size:14px;}
  .mapcont .linput{position:absolute;right:30px;top:50%;margin-top:-22px;text-align:right;width:50%;}
  .relativebox{position:relative;}
  .sublinewrap{margin-top:25px;}
  .sublinewrap p{display:inline-block;width:50%;float:left;margin-bottom:10px;}
  .sublinewrap p+p{margin-top:0;}
  .popwrap{position:fixed;background:rgba(0,0,0,0.5);left:0;right:0;top:0;bottom:0;z-index:11;}
  .popbox{position:absolute;width:1120px;margin-left:-560px;background:#fff;left:50%;top:50%;margin-top:-300px;height:600px;}
  .detailPage /deep/ .albumPage .swiper-slide{display:block;overflow:auto;height:600px;}
  .detailPage /deep/ .imgbox{width:840px;height:600px;}
  .el-icon-error{position:absolute;right:-10px;top:-10px;font-size:30px;z-index:1;cursor:pointer;}
  .estateInfo{position:absolute;right:20px;top:40px;z-index:1;width:20%;}
  .estateInfo .etitle{font-size:18px;font-weight:700;}
  .estateInfo .ephone{color:#F44336;font-size:18px;font-weight:bold;line-height:20px;margin-top:10px;}
  .otherwrap{padding-top:25px;
    li{padding-right:30px;float:left;}
    .o-left{width:170px;float:none;margin-right:0;}
    .o-right{float:none;padding-top:0;width:auto;}
    .imgwrap{height:120px;}
    .title{text-align:left;line-height:25px;margin-top:10px;}
    .type{float:left;margin-left:5px;}
    .area{float:left;}
  }
}
// @media (min-width:900px){
//   .sublinewrap p{width:33%;}
// }
// @media (min-width:1100px){
//   .popbox{width:1000px;left:50%;margin-left:-500px;top:50%;margin-top:-280px;height:560px;}
// }
// @media (min-width:1000px){
//   .b-img{width:60%;}
// }
</style>



// WEBPACK FOOTER //
// src/components/EstateDetail.vue